/*
This file is located in the main branch
Last time the file was updated (UTC): [17.07.2024 13:00:39]
Permissions to update outside the main branch: [false]
*/

import { AxiosInstance } from 'axios';
import { ConfigItem, ConfigItemChange } from 'models/api/config';

const controller = '/config/';

export const getConfigItem = async (axios: AxiosInstance, name: string) => {
    const response = await axios.get<ConfigItem>(controller + name);
    return response.data;
};

export const changeConfigItem = async (axios: AxiosInstance, item: ConfigItemChange) =>
    await axios.put<ConfigItemChange>(controller, item);
